import React from "react";
import CardForm from "okpay/components/CardForm";
import PayPalForm from "okpay/components/PayPalForm";
import CloseButton from "okpay/components/CloseButton";
import Summary from "okpay/components/Summary";
import C from "okpay/util/Constants";

import "./body.scss";

const Body = (props) => {
	let pageBody;
	let sideSummary;

	switch (props.billingType) {
		case C.billingTypes.card:
			pageBody = <CardForm {...props} />;
			break;
		case C.billingTypes.paypal:
			pageBody = <PayPalForm {...props} />;
			break;
		default:
			pageBody = <CardForm {...props} />;
			break;
	}

	if (props.productId !== "update") {
		sideSummary = (
			<div className="okpay-sidesummary">
				<Summary {...props} optionsBeforeTitle={true} />
			</div>
		);
	}

	return (
		<div className="okpay-body">
			<div className="okpay-form">{pageBody}</div>
			{sideSummary}
			<CloseButton />
		</div>
	);
};

export default Body;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/Body.jsx